import { getApiErrorMessage } from '@/shared/utils/parse-api-error-message.util';

export class CustomAuthenticationService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:3000';
  }

  async forgotPassword(
    email: string
  ): Promise<{ success: boolean; message?: string; error?: string }> {
    try {
      const response = await fetch(
        `${this.baseUrl}/portal/v1/identity/auth/forgot-password`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          error: getApiErrorMessage(
            data,
            'Erro ao processar solicitação de recuperação de senha',
          ),
        };
      }

      return {
        success: true,
        message: data.message || 'Email de recuperação enviado com sucesso',
      };
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Erro de conexão',
      };
    }
  }

  async confirmForgotPassword(
    email: string,
    verificationCode: string,
    newPassword: string
  ): Promise<{ success: boolean; message?: string; error?: string }> {
    try {
      const response = await fetch(
        `${this.baseUrl}/portal/v1/identity/auth/confirm-password-recovery`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email, verificationCode, newPassword }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          error: getApiErrorMessage(
            data,
            'Erro ao processar confirmação de recuperação de senha',
          ),
        };
      }

      return {
        success: true,
        message: data.message || 'Email de recuperação enviado com sucesso',
      };
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Erro de conexão',
      };
    }
  }
}

export const customAuthenticationService = new CustomAuthenticationService();
